<script>
import DoubleCameraIndex from './DoubleCameraIndex.vue'
import NormalIndex from './NormalIndex.vue'
import Loading from '@/components/Loading'

export default {
  components: {
    DoubleCameraIndex,
    NormalIndex,
    Loading
  },
  data() {
    return {
      isDoubleCamera: undefined,
      isOpenNetworkAndDevice: undefined,
      isOpenCamera: undefined,
      isOpenMic: undefined
    }
  },
  async mounted() {
    const queryExamId = this.$route.query.examId
    console.log(queryExamId)
    const decviveTypes = this.$store.state.site_msg.deviceTypes
    this.isOpenNetworkAndDevice = decviveTypes && decviveTypes.includes(1)
    this.isOpenCamera = decviveTypes && decviveTypes.includes(2)
    this.isOpenMic = decviveTypes && decviveTypes.includes(3)
    await this.$store.dispatch('getTestConfig')
    this.isDoubleCamera = queryExamId ? !!this.$store.state.testConfig.double_camera_monitor : false
  }
}
</script>
<template>
  <DoubleCameraIndex
    v-if="isDoubleCamera"
    :isOpenNetworkAndDevice="isOpenNetworkAndDevice"
    :isOpenCamera="isOpenCamera"
    :isOpenMic="isOpenMic"
  />
  <NormalIndex v-else-if="isDoubleCamera === false" />
  <div v-else class="loading-tourists-mask">
    <loading :box-size="14" :round-size="3" :color="'#306fff'"></loading>
  </div>
</template>
<style lang="scss">
.loading-tourists-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
